import gql from 'graphql-tag';

export const getApprovals = gql`
  query getApprovals {
    getApprovals {
      approvalId
      applicationId
      approvalType
      approvalNotes
      approvalReason
      approvalStatus
      updatedBy
      updatedAt
      erpOrg
      erpOrgName
      employeeName
      orgId
      orgUserId
      referenceNumber
      referenceVersion
      payrollNumber
      costCenter
      createdAt
      createdBy
    }
  }
`;

export const getApproval = gql`
  query getApproval($uuid: String!) {
    getApproval(uuid: $uuid) {
      approval {
        approvalId
        approvalType
        approvalNotes
        approvalReason
        approvalStatus
        orgId
        orgUserId
        applicationId
        referenceNumber
        referenceVersion
        erpOrg
        erpOrgName
        updatedBy
        updatedAt
        employeeName
        payrollNumber
        costCenter
      }
      application {
        applicationId
        applicationStatus
        metaData {
          acceptedQuote {
            id
            erpQuoteRef
            milesQuoteRef
            costCentre
            payrollNumber
            fbtValue
            monthlyRentalNet
            grossSalary
            title
          }
          creditCheck {
            address
            firstName
            middleName
            lastName
            income
            incomePeriod
          }
          quoteId
          creditCheckCompleted
          quotes
          fileId
        }
      }
    }
  }
`;

export const hrGrantApplicationApproval = gql`
  mutation hrApprovalCompletion(
    $uuid: String!
    $payLoad: ApprovalCompletionInput!
  ) {
    hrApprovalCompletion(uuid: $uuid, payLoad: $payLoad) {
      approvalId
      approvalType
      approvalNotes
      approvalReason
      approvalStatus
      orgId
      orgUserId
      applicationId
      referenceNumber
      erpOrg
      erpOrgName
      updatedBy
      updatedAt
      employeeName
      hrApprovedBy
      hrApprovedByName
      hrApprovedAt
      payrollNumber
      costCenter
    }
  }
`;

export const updateApproval = gql`
  mutation updateApproval($uuid: String!, $payLoad: ApprovalInput!) {
    updateApproval(uuid: $uuid, payLoad: $payLoad) {
      approvalId
      approvalType
      approvalNotes
      approvalReason
      approvalStatus
      orgId
      orgUserId
      applicationId
      referenceNumber
      erpOrg
      erpOrgName
      updatedBy
      updatedAt
      employeeName
      hrApprovedBy
      hrApprovedByName
      hrApprovedAt
      payrollNumber
      costCenter
    }
  }
`;
